import { cbHttp } from "./http.service";

export const deletionremoverelation = async (data: FormData): Promise<string> => {
    return cbHttp.post('/api/deletion/deletionremoverelation', data);
}

export const deletionremovedirecotry = async (data: FormData): Promise<string> => {
    return cbHttp.post('/api/deletion/deletionremovedirecotry', data);
}

export const deletionremovedb = async (data: FormData): Promise<string> => {
    return cbHttp.post('/api/deletion/deletionremovedb', data);
}

export const permaDeleteDomain = async (data: FormData): Promise<string> => {
    return cbHttp.post('/api/deletion/permadeletedomain', data);
}

export const deleteremovecompanyrelations = async (data: FormData): Promise<string> => {
    return cbHttp.post('/api/deletion/deleteremovecompanyrelations', data);
}

export const deletecompanyentry = async (data: FormData): Promise<string> => {
    return cbHttp.post('/api/deletion/deletecompanyentry', data);
}